<template>
  <v-menu v-model="show">
    <template v-slot:activator="{on}">
      <v-btn v-on="on" small tile>{{text}} <v-icon>menu</v-icon> </v-btn>
    </template>
    <v-list v-if="samples.length > 0">
      <v-menu  open-on-hover offset-x right >
        <template v-slot:activator="{on}">
          <v-list-item v-on="on">
            All
          </v-list-item>
        </template>
        <v-list>
          <v-list-item v-for="type in sampleNoteTypes" @click="updateAll(type.uuid)" :key="type.uuid">
            {{type.name}}
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu  v-for="(sample, index) in samples" :key="sample.id" open-on-hover offset-x right >
        <template v-slot:activator="{on}">
          <v-list-item v-on="on">
            {{index}} - {{sample.qa}}
          </v-list-item>
        </template>
        <v-list>
          <v-list-item v-for="type in sampleNoteTypes" @click="updateOne(type.uuid, index)" :key="type.uuid">
            {{type.name}}
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list>
  </v-menu>

</template>

<script>
export default {
  name: "CustomerSampleNoteMenu",
  components: {},
  data: () => ({
    show: false,
  }),
  props: {
      text: {
        required: true,
      },
      note: {
        required: true,
      },
      samples: {
        required: false,
        default: () => ([])
      }
  },
  computed: {
    sampleNoteTypes(){
      return this.$store.$db().model('sampleNoteTypes').all();
    },
  },
  methods: {
    updateAll(type){
      this.$emit("update_all", {
        uuid: null,
        sample_note_type_uuid: type,
        note: this.note,
        created_by: this.$store.getters.id,
        updated_by: this.$store.getters.id,
      })
      this.show = false;
    },
    updateOne(type, index){
      this.$emit("update_one", [index, {
        uuid: null,
        sample_note_type_uuid: type,
        note: this.note,
        created_by: this.$store.getters.id,
        updated_by: this.$store.getters.id,
      }])
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>
